import { set } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import {
  onChangeQuery,
  onClearQuery
} from '../../../actions/components/ro-picklist-search';

const defaultQuery = { q: '' };

const initialState = { query: defaultQuery };

const onChangeQueryHandler = action => ({
  [action.toString()]: (state, { payload: query }) => set('query', query, state)
});

const onClearQueryHandler = action => ({
  [action.toString()]: () => initialState
});

export default createReducer(initialState, {
  ...onChangeQueryHandler(onChangeQuery),
  ...onClearQueryHandler(onClearQuery)
});
